(function () {
  function isNewsletterForm(form) {
    const id = (form.getAttribute("id") || "").toLowerCase();
    const action = (form.getAttribute("action") || "").toLowerCase();

    const hasEmail = !!form.querySelector(
      'input[type="email"][name="contact[email]"], input[name="contact[email]"]'
    );
    const hasTag = !!form.querySelector(
      'input[name="contact[tags]"][value*="newsletter" i]'
    );

    const looksLikeNewsletter =
      id.includes("newsletter") || action.includes("#newsletter") || hasTag;

    return hasEmail && looksLikeNewsletter;
  }

  function isContactForm(form) {
    const action = (form.getAttribute("action") || "").toLowerCase();

    const hasFormTypeContact = !!form.querySelector(
      'input[name="form_type"][value="contact"]'
    );
    const hasBodyField = !!form.querySelector(
      'textarea[name="contact[body]"], textarea[name="contact[message]"], textarea[name="contact[comment]"]'
    );

    const looksLikeContact = action.includes("/contact") || hasFormTypeContact;
    return looksLikeContact && hasBodyField;
  }

  function wireConsent(form, wrapperSelector, checkboxSelector, lockSubmit) {
    const wrap = form.querySelector(wrapperSelector);
    if (!wrap) return;

    const checkbox = wrap.querySelector(checkboxSelector);
    if (!checkbox) return;

    const submit = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submit) return;

    // CSS-Scope aktivieren (dein theme.css nutzt .js-consent-form)
    form.classList.add("js-consent-form");

    if (!lockSubmit) return;

    const sync = () => {
      submit.disabled = !checkbox.checked;
    };

    checkbox.addEventListener("change", sync);
    sync();
  }

  function run() {
    document.querySelectorAll("form").forEach((f) => {
      if (isNewsletterForm(f)) {
        wireConsent(
          f,
          ".newsletter__consent, .newsletter__consent--js",
          ".js-newsletter-consent",
          true
        );
      }

      if (isContactForm(f)) {
        wireConsent(
          f,
          ".contact__consent, .contact__consent--js",
          ".js-contact-consent",
          true
        );
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Optional (nur wenn Formulare wirklich dynamisch per AJAX nachgeladen werden):
  // document.addEventListener("shopify:section:load", run);
})();
